const Mutations = Object.freeze({
	SET_CURRENT_USER: 'auth/SET_CURRENT_USER',
	SET_CURRENT_USER_PERMISSIONS: 'auth/SET_CURRENT_USER_PERMISSIONS',
	SET_ISAUTHENTICATED: 'auth/SET_ISAUTHENTICATED',
	SET_LOGIN_METHODS: 'auth/SET_LOGIN_METHODS',
	SET_PROFILE_LOADED: 'auth/SET_PROFILE_LOADED',
});

export const Actions = Object.freeze({
	LOGIN: 'auth/LOGIN',
	LOGIN_WINDOWS: 'auth/LOGIN_WINDOWS',
	LOAD_PROFILE: 'auth/LOAD_PROFILE',
	LOGOUT: 'auth/LOGOUT',
	LOAD_LOGIN_METHODS: 'auth/LOAD_LOGIN_METHODS',
	LOAD_WINDOWS_USERNAME: 'auth/LOAD_WINDOWS_USERNAME',
});

export const Getters = Object.freeze({
	CURRENT_USER: 'auth/CURRENT_USER',
	CURRENT_USER_ID: 'auth/CURRENT_USER_ID',
	IS_AUTHENTICATED: 'auth/IS_AUTHENTICATED',
	IS_SUPERADMIN: 'auth/IS_SUPERADMIN',
	PERMISSIONS: 'auth/PERMISSIONS',
	LOGIN_METHODS: 'auth/LOGIN_METHODS',
	PROFILE_LOADED: 'auth/PROFILE_LOADED',
});

import authenticationService from '../../services/authenticationService';
import userContextDataService from '../../services/data/userContextDataService';
import permissionCheckService from '../../services/permissionCheckService';
import jwtDecode from 'jwt-decode';
import { ClientContextActions, GeneralActions } from '../actions';
import { IrisLoginMethod } from '../../enums/irisLoginMethod';

export default {
	state: {
		currentUser: {
			userId: localStorage.bearer
				? jwtDecode(localStorage.bearer).nameid
				: '',
			firstName: localStorage.bearer
				? jwtDecode(localStorage.bearer).given_name
				: '',
			lastName: localStorage.bearer
				? jwtDecode(localStorage.bearer).family_name
				: '',
			email: localStorage.bearer
				? jwtDecode(localStorage.bearer).email
				: '',
			superAdmin: localStorage.bearer
				? jwtDecode(localStorage.bearer).SuperAdmin === 'true'
				: false,
			isAuthenticated: !!localStorage.bearer,
		},
		profileLoaded: false,
		permissions: [],
		loginMethods: [],
	},
	mutations: {
		[Mutations.SET_CURRENT_USER](state, item) {
			state.currentUser = item;
		},
		[Mutations.SET_CURRENT_USER_PERMISSIONS](state, items) {
			state.permissions = items;
			permissionCheckService.currentUserPermissions = items;
		},
		[Mutations.SET_PROFILE_LOADED](state, value) {
			state.profileLoaded = value;
		},
		[Mutations.SET_ISAUTHENTICATED](state) {
			if (state.currentUser)
				state.currentUser.isAuthenticated = !!localStorage.bearer;
		},
		[Mutations.SET_LOGIN_METHODS](state, items) {
			state.loginMethods = items;
		},
	},
	actions: {
		//TODO
		[Actions.LOAD_PROFILE]({ dispatch, commit, state }) {
			return new Promise((resolve) => {
				if (!state.currentUser.superAdmin) {
					dispatch(GeneralActions.LOADING, true);
					userContextDataService
						.getPermissions()
						.then((resp) => {
							commit(
								Mutations.SET_CURRENT_USER_PERMISSIONS,
								resp.data
							);
							commit(Mutations.SET_PROFILE_LOADED, true);
							resolve(resp.data);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(null);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					resolve(true);
				}
			});
		},
		[Actions.LOAD_LOGIN_METHODS]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				userContextDataService
					.getLoginMethods()
					.then((resp) => {
						commit(Mutations.SET_LOGIN_METHODS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.LOAD_WINDOWS_USERNAME]({ dispatch }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				authenticationService
					.getWindowsUsername()
					.then((resp) => {
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},

		[Actions.LOGIN]({ commit }, userCredentials) {
			return new Promise((resolve, reject) => {
				authenticationService
					.login(userCredentials)
					.then(({ data }) => {
						let decodedJWT = jwtDecode(data);
						let currentUser = {
							userId: decodedJWT.nameid,
							firstName: decodedJWT.given_name,
							lastName: decodedJWT.family_name,
							email: decodedJWT.email,
							superAdmin: decodedJWT.SuperAdmin,
						};
						localStorage.bearer = data;
						localStorage.last_login_type = IrisLoginMethod.Forms;
						commit(Mutations.SET_CURRENT_USER, currentUser);
						commit(Mutations.SET_ISAUTHENTICATED);
						resolve();
					})
					.catch((error) => {
						reject(error);
					});
			});
		},

		[Actions.LOGIN_WINDOWS]({ commit }) {
			return new Promise((resolve, reject) => {
				authenticationService
					.loginWindows()
					.then(({ data }) => {
						let decodedJWT = jwtDecode(data);
						let currentUser = {
							userId: decodedJWT.nameid,
							firstName: decodedJWT.given_name,
							lastName: decodedJWT.family_name,
							email: decodedJWT.email,
							superAdmin: decodedJWT.SuperAdmin,
						};
						localStorage.bearer = data;
						localStorage.last_login_type = IrisLoginMethod.Windows;
						commit(Mutations.SET_CURRENT_USER, currentUser);
						commit(Mutations.SET_ISAUTHENTICATED);
						resolve();
					})
					.catch((error) => {
						reject(error);
					});
			});
		},

		[Actions.LOGOUT]({ commit, dispatch }) {
			return new Promise((resolve) => {
				dispatch(ClientContextActions.CLEAR).then(() => {
					commit(Mutations.SET_CURRENT_USER, null);
					commit(Mutations.SET_CURRENT_USER_PERMISSIONS, []);
					commit(Mutations.SET_PROFILE_LOADED, false);
					permissionCheckService.selectedProject = null;
					localStorage.removeItem('bearer');
					localStorage.removeItem('last_login_type');
					commit(Mutations.SET_ISAUTHENTICATED);
					resolve();
				});
			});
		},
	},
	getters: {
		[Getters.CURRENT_USER]: (state) => {
			return state.currentUser;
		},
		[Getters.CURRENT_USER_ID]: (state) => {
			if (!state.currentUser) return false;
			return state.currentUser.userId;
		},
		[Getters.IS_AUTHENTICATED]: (state) => {
			if (!state.currentUser) return false;
			return state.currentUser.isAuthenticated;
		},
		[Getters.PERMISSIONS]: (state) => {
			if (state && state.permissions) return state.permissions;
			return [];
		},
		[Getters.PROFILE_LOADED]: (state) => {
			if (!state.currentUser) return false;
			if (state.currentUser.superAdmin) return true;
			return state.profileLoaded;
		},
		[Getters.IS_SUPERADMIN]: (state) => {
			if (!state.currentUser) return false;
			return state.currentUser.superAdmin;
		},

		[Getters.LOGIN_METHODS]: (state) => {
			if (!state.loginMethods) return [];
			if (state.loginMethods.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.loginMethods));
		},
	},
};
